import { ReviewItem, ReviewItemProps } from './ReviewItem'

export default ReviewItem

export { type ReviewItemProps, ReviewItem }
